import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';

import PageLayout from '../_partials/PageLayout';
import { Spin } from "antd";
import './style.scss';
import { fetchUsernameStyles } from "../../../actions/mine_craft/usernameStylesActions";
import List from "../../mine_craft/UsernameStyles/_partials/_List";
import PageHeader from "src/componets/PageHeader";
import Wrapper from "../../../componets/Wrapper";
import NavBarThree from "../../../componets/NavBarThree";
import {PlusOutlined, SettingOutlined} from "@ant-design/icons";
import { selectUsernameStyleIds, setNewParams, setReorderIds } from "../../../store/mine_craft/usernameStylesSlice";
import { queryParams } from "../../../helpers/UrlHelpers";
import { useSearchParams } from "react-router-dom";
import Filter, {FilterInterface} from "../../../componets/Filter";
import New from "./New";
import Settings from "./Settings";

export interface PropsInterface {
  appId: 1 | 2;
}
const LIMIT = 42;

const UsernameStyles = ({ appId }: PropsInterface) => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const status = useAppSelector(state => state.mineCraft.usernameStyles.status);
  const error = useAppSelector(state => state.mineCraft.usernameStyles.error);
  const ids = useAppSelector(selectUsernameStyleIds);
  const currentPage = queryParams.getInt(searchParams,'page') || 1;
  const filterProps: FilterInterface = {};

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        app_id: appId,
        limit: LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['order_by', 'order', 'date_from', 'date_to']
    );

    dispatch(fetchUsernameStyles(params));
  }, [dispatch, appId, currentPage, searchParams]);

  function onClickCreate() {
    const params: any = {
      app_id: appId,
      text_gradient_angle: 0,
      stroke_gradient_angle: 0,
      stroke_width: 0,
      coins: 0
    };

    dispatch(setNewParams(params));
  }

  function onSettings() {
    dispatch(setReorderIds({ ids }));
  }

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  filterProps.orderBy = {
    defaultKey: 'id',
    defaultSort: 'desc',
    items: [
      { name: 'Date', key: 'id' },
    ]
  };

  return (
    <PageLayout>
      <PageHeader
        align='right'
        title='Username Styles'
      >
        <NavBarThree>
          <NavBarThree.Button onClick={onSettings}>
            <SettingOutlined /> Username Styles Settings
          </NavBarThree.Button>
        </NavBarThree>
      </PageHeader>

      <Wrapper>
        <NavBarThree>
          <NavBarThree.Button className='v-link2' onClick={onClickCreate}>
            <PlusOutlined /> Create Username Style
          </NavBarThree.Button>
        </NavBarThree>
      </Wrapper>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            dateRange
            {...filterProps}
          />
        </Wrapper>

        <List limit={LIMIT} pagination={true} />

        <New />
        <Settings />
      </div>
    </PageLayout>
  );
}

export default UsernameStyles;
